import { USER_ROLE } from '../../../../../constant/user';
import { BLOCK_TEMPLATE } from '../models';

export const INITIAL_LOBBY_PAGE_MODEL = {
    questionButton: false,
    programButton: false,
};

export const LOBBY_BLOCKS_LIST = [
    {
        template: BLOCK_TEMPLATE.POSTER,
    },
    {
        template: BLOCK_TEMPLATE.COUNTDOWN,
    },
    {
        template: BLOCK_TEMPLATE.PARTNERS,
    },
    {
        template: BLOCK_TEMPLATE.COVER,
    },
    {
        template: BLOCK_TEMPLATE.QUIZZES,
        allowMultiple: true,
    },
    {
        template: BLOCK_TEMPLATE.CUSTOM_WIDGET,
        availableForAdmin: true,
    },
];
